import React, { useEffect, useState } from 'react';
import {
  createDuration,
  getDurationParts,
  subtractDuration,
} from 'src/utils/time';
import styled from 'styled-components';

export interface TimerProps {
  interval?: ReturnType<typeof createDuration>;
}

export const Timer: React.FC<TimerProps> = ({
  interval = createDuration({ seconds: 0, minutes: 60, hours: 0 }),
}) => {
  const [duration, setDuration] = useState(interval);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newDuration = subtractDuration(duration, 1, 'seconds');
      setDuration(createDuration(getDurationParts(newDuration)));

      if (newDuration.asSeconds() <= 0) {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [duration]);

  const { hours, minutes, seconds } = getDurationParts(duration);

  return (
    <TimerStyled data-testid={'token-timer'}>{`${hours.toLocaleString(
      undefined,
      { minimumIntegerDigits: 2 },
    )}:${minutes.toLocaleString(undefined, {
      minimumIntegerDigits: 2,
    })}:${seconds.toLocaleString(undefined, {
      minimumIntegerDigits: 2,
    })} minutes`}</TimerStyled>
  );
};

const TimerStyled = styled.div`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  font-size: 16px;
`;
